<div class="share-dialog">
  <div mat-dialog-title class="share-dialog__title">
    <div class="header-first-line">
      <h4 class="mat-headline-large">Share</h4>
      <button (click)="close()" class="close" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="share-dialog__header">
      <p class="subtitle mat-body-large">
        Invite your friends to join FantaZ and you will earn commissions as a
        ZBO
      </p>
    </div>
  </div>

  <div mat-dialog-content class="share-dialog__content">
    <div class="row">
      <div>
        <fz-share
          *ngIf="data"
          [shareLabel]="'Share your FantaZ Link'"
          [profileLink]="profileLink"
          [isZbo]="canShareWithFantazEmail"
          [shareOptions]="shareOptions"
          (shareBy)="onShare($event)"
        ></fz-share>
      </div>
    </div>
    @if (visibleEmail) {
      <div class="mb--3">
        <form [formGroup]="inviteForm" novalidate class="invite-tools">
          @if (profileLink) {
            <div class="input-group invite-form">
              <div class="input-email-wrapper">
                <mat-form-field class="full-width">
                  <input
                    class="input-email"
                    matInput
                    formControlName="email"
                    trim="true"
                    type="email"
                    name="inviteEmail"
                    id="inviteEmail"
                    placeholder="Invite by email"
                    tabindex="1"
                    [ngClass]="{
                      'is-invalid':
                        inviteForm.controls.email.dirty &&
                        inviteForm.controls.email.errors
                    }"
                    required
                  />

                  <mat-error>
                    @if (inviteForm.get('email')?.hasError('required')) {
                      Email is required.
                    }
                    @if (inviteForm.get('email')?.hasError('email')) {
                      The email address is invalid.
                    }
                  </mat-error>
                </mat-form-field>
              </div>
              <button
                class="input-group-btn send-button"
                mat-flat-button
                color="primary"
                type="button"
                (click)="inviteMember()"
                type="submit"
                data-ga-value="promote-send-button"
                [disabled]="inviting === true"
              >
                Send
              </button>
              @if (inviteResponse !== '' && invitationError === false) {
                <div class="primary-color">
                  {{ inviteResponse }}
                </div>
              }
              @if (inviteResponse !== '' && invitationError === true) {
                <div class="primary-darker-color">
                  <small> {{ inviteResponse }}</small>
                </div>
              }
            </div>
          }
        </form>
      </div>
    }
    @if (isPromote === true) {
      <section class="videos-container">
        <mat-checkbox
          class="no-margin"
          color="primary"
          [checked]="true"
          [(ngModel)]="showVideos"
          (change)="onShowVideosChange()"
          >Send a tutorial video with invitation</mat-checkbox
        >
        <div class="videos" [hidden]="showVideos !== true">
          <div *ngIf="profileLink">
            <div class="radios-ctn">
              <mat-radio-group
                class="radio-group"
                aria-label="Select an option"
              >
                <div
                  class="custom-video-player-ctn"
                  [ngClass]="{ shrink: visibleEmail }"
                  [class.selected]="videoSelected === femaleVideoId"
                >
                  <fz-shared-ui-video-player
                    videoPoster="/shared/img/promote/kimi.png"
                    [videoUrl]="introFemaleVideoUrl"
                    (playVideo)="onVideoPlayed()"
                    (videoEnded)="onVideoEnded()"
                    (videoPaused)="onVideoPaused()"
                  ></fz-shared-ui-video-player>
                  <mat-radio-button
                    color="primary"
                    [value]="femaleVideoId"
                    [checked]="true"
                    (change)="genderVideoChange($event)"
                    >Kimi</mat-radio-button
                  >
                </div>
                <div
                  class="custom-video-player-ctn"
                  [ngClass]="{ shrink: visibleEmail }"
                  [class.selected]="videoSelected === maleVideoId"
                >
                  <fz-shared-ui-video-player
                    videoPoster="/shared/img/promote/dustin.png"
                    [videoUrl]="introMaleVideoUrl"
                    (playVideo)="onVideoPlayed()"
                    (videoEnded)="onVideoEnded()"
                    (videoPaused)="onVideoPaused()"
                  ></fz-shared-ui-video-player>
                  <mat-radio-button
                    color="primary"
                    [checked]="false"
                    [value]="maleVideoId"
                    (change)="genderVideoChange($event)"
                    >Dustin</mat-radio-button
                  >
                </div>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </section>
    }
  </div>
</div>
